import { useMutation, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/api/queryKeys';
import {
  ReplaceEmailNotificationRoleAccess,
  UserEmailNotificationPreferenceItem,
} from '@/types';
import { emailNotifications } from '../EmailNotifications';

type OptionsType = { enabled?: boolean };

export const useEmailNotificationRoleAccess = (
  userType?: string,
  userRole?: string,
  options?: OptionsType,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.emailNotificationRoleAccess, userType, userRole],
    queryFn: async () =>
      (await emailNotifications.getRoleAccess(userType, userRole)).data,
    enabled: options?.enabled,
  });

export const useNovuWorkflowOptions = (options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.novuWorkflowOptions],
    queryFn: async () => (await emailNotifications.getWorkflows()).data,
    enabled: options?.enabled,
  });

export const useReplaceEmailNotificationRoleAccess = () =>
  useMutation({
    mutationFn: (data: ReplaceEmailNotificationRoleAccess) =>
      emailNotifications.replaceRoleAccess(data),
  });

export const useMyEmailNotificationPreferences = (options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.myEmailNotificationPreferences],
    queryFn: async () => (await emailNotifications.getMyPreferences()).data,
    enabled: options?.enabled,
  });

export const useUpdateMyEmailNotificationPreferences = () =>
  useMutation({
    mutationFn: (items: UserEmailNotificationPreferenceItem[]) =>
      emailNotifications.updateMyPreferences(items),
  });
